export default function About() {
  return (
    <div data-testid="about-page" className="max-w-3xl px-6 md:px-12 py-16">
      <div className="label-eyebrow text-muted-foreground mb-3">
        ◼ ABOUT FORGE
      </div>
      <h1 className="font-display text-5xl md:text-6xl uppercase tracking-tighter">
        Public AI image archive
      </h1>
      <p className="mt-6 text-lg leading-relaxed">
        Forge is a public sandbox for generating and archiving AI images. Type
        a prompt, choose a model, and the resulting image is permanently
        stored with its own URL — ready to share, embed or reference anywhere
        on the web.
      </p>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-0 border-2 border-black">
        <div className="p-6 border-b-2 md:border-b-0 md:border-r-2 border-black">
          <div className="label-eyebrow text-muted-foreground">Engine A</div>
          <div className="font-display text-2xl mt-2">Gemini Nano-Banana</div>
          <p className="mt-3 font-mono text-sm text-muted-foreground">
            Google&apos;s latest image preview model — fast and stylistically wide.
          </p>
        </div>
        <div className="p-6">
          <div className="label-eyebrow text-muted-foreground">Engine B</div>
          <div className="font-display text-2xl mt-2">OpenAI GPT-Image-1</div>
          <p className="mt-3 font-mono text-sm text-muted-foreground">
            OpenAI&apos;s image generator — photoreal, sharp typography, clean
            composition.
          </p>
        </div>
      </div>
    </div>
  );
}
